var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcMaxVolume = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8.758 2.267C10.59.206 14 1.502 14 4.26v15.48c0 2.758-3.41 4.055-5.242 1.993l-3.909-4.397A1 1 0 0 0 4.102 17H3a3 3 0 0 1-3-3v-4a3 3 0 0 1 3-3h1.102a1 1 0 0 0 .747-.336zm10.605 1.956a1 1 0 0 1 1.414 0 11 11 0 0 1 0 15.554 1 1 0 0 1-1.414-1.414 9 9 0 0 0 0-12.726 1 1 0 0 1 0-1.414m-2.53 3.53a1 1 0 0 1 1.414 0 6 6 0 0 1 0 8.484 1 1 0 0 1-1.414-1.414 4 4 0 0 0 0-5.656 1 1 0 0 1 0-1.414",
  clipRule: "evenodd"
})));
export default SvgIcMaxVolume;